import { z } from 'zod';

const passwordSchema = z
  .string()
  .min(8, 'At least 8 characters')
  .regex(/[A-Z]/, 'One uppercase letter')
  .regex(/[a-z]/, 'One lowercase letter')
  .regex(/[0-9]/, 'One number')
  .regex(/[^A-Za-z0-9]/, 'One special character');

const withConfirmPassword = <
  T extends Record<string, z.ZodType> & { newPassword: z.ZodType<string> },
>(
  schema: z.ZodObject<T>
) =>
  schema
    .extend({
      confirmPassword: z.string(),
    })
    .refine(
      (data) => {
        const d = data as { newPassword: string; confirmPassword: string };
        return d.newPassword === d.confirmPassword;
      },
      {
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      }
    );

export const changePasswordOneTimeSchema = withConfirmPassword(
  z.object({
    newPassword: passwordSchema,
  })
);

export const changePasswordSchema = withConfirmPassword(
  z.object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: passwordSchema,
  })
);

export const resetPasswordSchema = withConfirmPassword(
  z.object({
    code: z.string().min(1, 'Verification code is required'),
    newPassword: passwordSchema,
  })
);

export const emailSchema = z.object({
  email: z.string().email('Enter a valid email'),
});
